import InputFieldOutlined from 'component/Inputs/dashboard-input'
import Loader from 'component/loader'
import SearchIcon from 'icon/search'
import SortIcon from 'icon/sort'
import React, { useEffect, useState } from 'react'

function Table({
  columns = [],
  rows = [],
  loader,
  isSearchable,
  isSortable,
  isDeepSearch,
  fixedHeader,
  height,
  onRowClick
}) {
  const [filteredRows, setFilteredRows] = useState([])
  const [sortOrder, setSortOrder] = useState({})

  const deepSearch = (ReactObject, query) => {
    if (typeof ReactObject.props.children == 'string') {
      const value = ReactObject.props.children
      return value.toLowerCase().includes(query.toLowerCase())
    }
    if (!Array.isArray(ReactObject.props.children))
      return deepSearch(ReactObject.props.children, query)

    return false
  }

  const handleSearch = (e) => {
    const { value: query } = e.target
    if (!query) {
      return setFilteredRows(rows)
    }
    const filtered = rows.filter((row) => {
      return Object.values(row).some((value) => {
        if (typeof value == 'string')
          return value.toLowerCase().includes(query.toLowerCase())

        if (isDeepSearch) return deepSearch(value, query)
        return false
      })
    })
    setFilteredRows([...filtered])
  }

  const handleSort = (accessor, order) => {
    const newSortOrder = order === 'asc' ? 'desc' : 'asc'
    setSortOrder({ ...sortOrder, [accessor]: newSortOrder })

    let sortedRows = [...rows].sort((a, b) => {
      a = a[accessor]
      b = b[accessor] || ''
      if (order === 'asc') return a > b ? 1 : -1
      else return a > b ? -1 : 1
    })
    setFilteredRows(sortedRows)
  }

  useEffect(() => {
    setFilteredRows(rows)
  }, [rows])

  return (
    <div
      className='relative overflow-x-auto shadow-md sm:rounded-xl border border-[#BA141B]/20'
      style={{ maxHeight: height }}
    >
      {isSearchable && (
        <div className='bg-white flex justify-between py-4 px-6 border-b border-gray-200'>
          <div className='w-full max-w-md'>
            <InputFieldOutlined
              placeholder={'Search'}
              onChange={handleSearch}
              StartIcon={<SearchIcon className="text-[#BA141B]" />}
              inputClass="border-[#BA141B]/40 focus:border-[#F5821F] focus:ring-[#F5821F]/20"
            />
          </div>
        </div>
      )}

      <table className='w-full text-sm text-left rtl:text-right text-gray-700'>
        <thead
          className={`text-xs text-[#BA141B] uppercase bg-gray-50/80 font-medium ${
            fixedHeader ? 'sticky top-0 z-10' : ''
          }`}
        >
          <tr>
            {columns.map((header) => (
              <th
                scope='col'
                className='px-6 py-4 group/header'
                style={{ width: header.width }}
              >
                <div className='flex items-center'>
                  {header.name}

                  {isSortable && (
                    <SortIcon
                      onClick={() =>
                        handleSort(
                          header.accessor,
                          sortOrder[header.accessor] || 'asc'
                        )
                      }
                      size={12}
                      className={
                        'ml-auto text-[#BA141B]/70 hover:text-[#BA141B] hidden group-hover/header:block transition-colors'
                      }
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>

        <tbody className='divide-y divide-gray-100'>
          {loader ? (
            <tr className='bg-white'>
              <td colSpan={columns.length} className='py-12 text-center'>
                <Loader />
              </td>
            </tr>
          ) : (
            filteredRows.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => onRowClick?.(row)}
                className={`
                  bg-white border-b transition-colors duration-150
                  ${onRowClick ? 'cursor-pointer hover:bg-[#F5821F]/5' : ''}
                `}
              >
                {columns.map((col, idx) =>
                  idx === 0 ? (
                    <th
                      scope='row'
                      className='px-6 py-4 font-medium text-gray-900 whitespace-nowrap'
                    >
                      {row[col.accessor]}
                    </th>
                  ) : (
                    <td className='px-6 py-4'>{row[col.accessor]}</td>
                  )
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}

export default Table